<template>
  <div>
    <swatches v-model="color" disabled/>
  </div>
</template>

<script>
  import Swatches from 'vue-swatches'

  import "vue-swatches/dist/vue-swatches.min.css"

  export default {
    name: "AdminColor",
    components: { Swatches },
    props: {
        color: String
    },
    data () {
      return {
       
      }
    }
  }
</script>